'use strict'
export default (object = {}, path = null) => {
    try{
        let aux = path.split('.');
        for (let i = 0; i < aux.length; ++i) {
            object = object[aux[i]];
        }
        return object;
    }catch(err){
        return undefined;
    }
}